export const IntegrationsMenuStructure = {
  title: "Integrations",
  links: [],
};

const legacyIntegrationsMenuStructure = (availableIntegrations) => {
  const integrationLinks = availableIntegrations.map((integration) => ({
    title: integration.syncFriendlyName,
    href: `integrations/${integration.syncName}`,
  }));

  return {
    title: "Integrations",
    links: [
      {
        title: "Select Integration",
        href: "integrations",
        exact: true,
      },
      ...integrationLinks,
    ],
  };
};

export default legacyIntegrationsMenuStructure;
